/**
 * 測定端末ページ用のスクリプト
 */
var device_treemultiselect = null;

 if (is_route('device.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        device_event_set();
        device_setting_event_set();
        device_batch_transfer_event_set();
        device_csv_event_set();
        device_search_event_set();
    });

    // 測定端末画面のみ：グループ会社・会社・営業所のドロップダウンを「選択しても検索しない」に変更する。
    // 共通の affiliation.js が click 時に即リダイレクトするため、capture フェーズで先に介入し
    // stopImmediatePropagation で共通ハンドラの実行を抑止する。検索ボタン押下時に保留中の選択を URL に反映する。
    window.devicePendingAffiliation = window.devicePendingAffiliation || {};

    // ツールバーの会社/営業所ドロップダウンの選択肢を AJAX で差し替える
    function deviceRebuildAffiliationMenu($menu, type, options) {
        $menu.find('.dropdown-item').remove();
        (options || []).forEach(function(opt) {
            if (!opt || opt.id === '' || opt.id == null) { return; }
            var $a = $('<a class="dropdown-item pointer"></a>')
                .attr('data-' + type + '_id', opt.id);
            var $span = $('<span></span>')
                .attr('data-replace-name-' + type + '-id', opt.id)
                .text(opt.text);
            $a.append($span);
            $menu.append($a);
        });
    }

    function deviceReloadAffiliationOptions(type, parentKey, parentId) {
        var $menu = $('.dropdown-menu[aria-labelledby="user-' + type + '-config"]');
        if (!$menu.length) { return; }
        if (!parentId) {
            $menu.find('.dropdown-item').remove();
            return;
        }
        // ツールバーのドロップダウン（$holding->companies / $company->sections）と同じデータを返す専用エンドポイントを使用する
        var url = type === 'company'
            ? '/option/affiliation_companies'
            : '/option/affiliation_sections';
        var data = {};
        data[parentKey] = parentId;
        _ajax.background(url, data, function(results) {
            deviceRebuildAffiliationMenu($menu, type, results && results.options ? results.options : []);
        }, function() {
            // 失敗時はそのまま
        });
    }

    // ドロップダウンのトグル（選択中表示）の中身を再構築する
    // ラベル(<label>) + 画像(<img>任意) + 名称(<span>) の構造で組み立てる
    var DEVICE_AFFILIATION_LABELS = {
        'holding': 'グループ会社',
        'company': '会社',
        'section': '営業所'
    };
    var DEVICE_AFFILIATION_NO_SELECT = {
        'holding': 'グループ会社を選択',
        'company': '会社を選択',
        'section': '営業所を選択'
    };

    function deviceSetAffiliationToggle(type, id, name) {
        var $toggle = $('#user-' + type + '-config');
        if (!$toggle.length) { return; }
        if (!id || !name) {
            $toggle.empty().text(DEVICE_AFFILIATION_NO_SELECT[type] || '');
            return;
        }
        var $label = $('<label></label>').text(DEVICE_AFFILIATION_LABELS[type] || '');
        var $span = $('<span></span>')
            .attr('data-replace-name-' + type + '-id', id)
            .text(name);
        $toggle.empty().append($label).append(' ').append($span);
    }

    // 下位階層の選択中表示（ラベル）を空にする
    function deviceClearAffiliationToggle(type) {
        deviceSetAffiliationToggle(type, null, null);
    }

    // 親（holding/company）に紐づく子（company/section）の <li> がツールバーに存在しない場合に
    // blade（parts/affiliation/{company,section}/dropdown.blade.php）と同じ骨組みを差し込む。
    // blade 側は `count($models) > 0` の条件下でしか描画しないため、親選択直後で子件数0件の状態だと
    // toggle / dropdown-menu の双方が DOM に存在せず、JS から AJAX 投入できないケースをカバーする。
    function deviceEnsureAffiliationLi(type) {
        if ($('#user-' + type + '-config').length) { return true; }
        var parentType = (type === 'company') ? 'holding' : (type === 'section') ? 'company' : null;
        if (!parentType) { return false; }
        var $parentLi = $('#user-' + parentType + '-config').closest('li');
        if (!$parentLi.length) { return false; }
        var $li = $(
            '<li class="affiliation-link nav-item dropdown user-menu">' +
                '<a class="nav-link dropdown-toggle" href="#" id="user-' + type + '-config" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>' +
                '<div class="dropdown-menu" aria-labelledby="user-' + type + '-config">' +
                    '<div class="dropdown-searchbox">' +
                        '<input type="text" class="form-control mr-1" id="user-' + type + '-seach" placeholder="検索キーワードを入力" autocomplete="off">' +
                    '</div>' +
                '</div>' +
            '</li>'
        );
        $li.find('a.dropdown-toggle').text(DEVICE_AFFILIATION_NO_SELECT[type] || '');
        $parentLi.after($li);
        return true;
    }

    // 指定 type の <li> 自体をツールバーから取り除く
    function deviceRemoveAffiliationLi(type) {
        var $toggle = $('#user-' + type + '-config');
        if (!$toggle.length) { return; }
        $toggle.closest('li').remove();
    }

    if (!window.deviceAffiliationOverrideInstalled) {
        window.deviceAffiliationOverrideInstalled = true;

        document.addEventListener('click', function(e) {
            if (!is_route('device.index')) { return; }

            var item = e.target.closest && e.target.closest('.dropdown-item');
            if (!item) { return; }
            var menu = item.closest('.dropdown-menu');
            if (!menu) { return; }

            var aria = menu.getAttribute('aria-labelledby');
            var typeKey = null;
            var clearKeys = [];
            if (aria === 'user-holding-config') {
                typeKey = 'holding_id';
                clearKeys = ['company_id', 'section_id'];
            } else if (aria === 'user-company-config') {
                typeKey = 'company_id';
                clearKeys = ['section_id'];
            } else if (aria === 'user-section-config') {
                typeKey = 'section_id';
                clearKeys = [];
            } else {
                return;
            }

            var $item = $(item);
            var newId = $item.data(typeKey);
            var $itemSpan = $item.find('span').first();
            var newName = $itemSpan.length ? $.trim($itemSpan.text()) : '';

            // 保留状態を更新（下位階層の選択は明示的にクリア）
            window.devicePendingAffiliation[typeKey] = newId;
            clearKeys.forEach(function(k) {
                window.devicePendingAffiliation[k] = null;
            });

            // ツールバー表示を更新（既存の <span> が無いケースもあるため、毎回中身を組み立て直す）
            var type = typeKey.replace('_id', '');
            deviceSetAffiliationToggle(type, newId, newName);
            var $toggle = $('#user-' + type + '-config');

            // 選択状態（青いバー）の表示
            $(menu).find('.dropdown-item').removeClass('active');
            $item.addClass('active');

            // 下位階層のラベル表示と選択肢を更新する
            if (typeKey === 'holding_id') {
                // グループ選択時は会社のみ表示。営業所は会社が選ばれるまで toolbar から消す。
                deviceEnsureAffiliationLi('company');
                deviceRemoveAffiliationLi('section');
                deviceClearAffiliationToggle('company');
                deviceReloadAffiliationOptions('company', 'holding_id', newId);
            } else if (typeKey === 'company_id') {
                deviceEnsureAffiliationLi('section');
                deviceClearAffiliationToggle('section');
                deviceReloadAffiliationOptions('section', 'company_id', newId);
            }

            // ドロップダウンを閉じる
            $(menu).removeClass('show');
            $toggle.removeClass('show').attr('aria-expanded', 'false');
            var $parentLi = $toggle.closest('.dropdown');
            if ($parentLi.length) { $parentLi.removeClass('show'); }

            // 共通の affiliation.js のクリックハンドラ（即リダイレクト）の実行を抑止する
            e.stopImmediatePropagation();
            e.preventDefault();
        }, true);
    }
}
/**
 * ページ読み込み時のイベント設定
 */
 window.device_event_set = function() {

    // 検索用のインプットフォームの変更時にformの発火を防ぐ
    $(document).on('change','#device-search-form input', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function (e) {
        // バブリングを禁止
        e.stopPropagation();
        // 設定モーダル表示
        _modal.create(this, 'setting-modal', ['id', 'type'], true);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#device-all-delete', function () {
        $(".device-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.device-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#device-all-delete, .device-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#device-multi-delete-button').prop('disabled', ($('.device-delete:checked').length == 0));
    });

    /*---- 所属一括変更表示時 ----*/

    // 所属一括変更表示時
    $(document).on('click', '#search-form-action_batch_transfer', function () {
        _modal.create(this, 'batch-transfer-modal', ['id', 'type'], false, function() {
            user_treemultiselect = initialize_treemultiselect();
        });
    });

    // /*---- 削除確認時 ----*/

    // // 削除確認時
    // $(document).on('click', '[data-confirm-modal]', function () {
    //     _modal.create(this, 'confirm-modal', ['id']);
    // });

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.device-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    // /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });

    // /*---- CSVダウンロード時(測定端末全て) ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download_all', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#-csv-setting-modal-csv-submit-message').addClass('display-none');
        $('#device-csv-setting-modal-csv-submit-message').empty();
        $('#device-csv-setting-modal-csv-error').addClass('display-none');
        $('#device-csv-setting-modal-csv-error').empty();
        $('#device-csv-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#device-csv-setting-modal-csv', function () {
        let modalId = '#device-csv-setting-modal';
        let formId = '#device-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#device-csv-setting-modal-csv').val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#device-csv-setting-modal';
        let formId = '#device-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });

    //アコーディオンをクリックした時の動作
    $(document).on('change', '.is_dest_section', function () {//要素をクリックしたら
        var findElm = $(".box1");//直後のアコーディオンを行うエリアを取得し
        $(findElm).slideToggle(0.2);//アコーディオンの上下動作
    });

    /*---- 返却確認時 ----*/

    // 返却確認時
    $(document).on('click', '[data-return-confirm-modal]', function () {
        _modal.create(this, 'return-confirm-modal', ['id']);
        e.stopPropagation();
    });

    /*---- 返却時 ----*/

    // 返却実行時
    $(document).on('click', '[data-return-modal]', function () {
        _modal.submit(this, 'return-modal');
    });
}
/**
 * 設定モーダル表示時のイベント設定
 */
 window.device_setting_event_set = function() {

    //アコーディオンをクリックした時の動作
    $(document).on('change', '#device-setting-modal-dest_section_id', function () {//要素をクリックしたら
        let action = $('#dest_section_forms').data('action');

        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#device-setting-modal-id').val()},
            {'name': 'dest_company_id', 'value': $('#device-setting-modal-dest_company_id').val()},
            {'name': 'dest_section_id', 'value': $('#device-setting-modal-dest_section_id').val()},
        ], function (results) {
            $('#dest_section_forms').html(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html')
    });
}

/**
 * 設定モーダル表示時のイベント設定
 */
window.device_batch_transfer_event_set = function () {

    setTreeMultiSelect('#device-batch-transfer-modal-section_id', 'select.devices-select', {'type': 'transfer'});

    // 送信イベント変更時
    $(document).on('change', '#device-batch-transfer-modal-change_events', function () {
        let value = $(this).val();
        $('.setting-part').each(function() {
            $(this).addClass('display-none');
        });
        $('.setting-'+value).removeClass('display-none');
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                user_treemultiselect[0][0].remove();
                user_treemultiselect[0][0].reload();
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.company_name + '|' + option.section_name
                    }).text(option.text));
                })
                user_treemultiselect[0][0].reload();
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-batch-transfer-save-modal]', function () {
        _modal.submit(this, 'batch-transfer-save-modal', function(results) {
            _modal.hide('#device-batch-transfer-modal');
        });
    });

}

window.device_csv_event_set = function() {

    /*---- ヘルプボタン押下時 ----*/

    $(document).on('click', '.modal-device-description', function () {
        _modal.show('#device-csv-description-modal');
    });

}

/**
 * デバイス検索イベント設定
 */
window.device_search_event_set = function() {
    // 多重送信防止用フラグ
    let deviceSearchProcessFlag = false;

    // デバッグモード（開発時のみ有効にする）
    const debugMode = true;

    if (debugMode) {
        console.log('Device search event set initialized');
    }

    // // 複数選択チェックボックスの変更を監視して、URLを直接更新
    // $(document).on('change', '#search-form .multi-check input[type="checkbox"]', function() {
    //     if (deviceSearchProcessFlag) {
    //         if (debugMode) console.log('Multi-check search already in progress, skipping');
    //         return;
    //     }

    //     deviceSearchProcessFlag = true;

    //     if (debugMode) {
    //         console.log('Device multi-check search triggered by:', $(this).attr('name'), 'checked:', $(this).is(':checked'));
    //     }

    //     // 少し遅延させてから検索実行（複数のチェックボックスが連続で変更される場合を考慮）
    //     setTimeout(function() {
    //         device_multiple_select_search();
    //         deviceSearchProcessFlag = false;
    //     }, 200);
    // });

    // 全て選択用のチェックボックス
    $(document).on('change', '#all-select-status-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // if (deviceSearchProcessFlag) {
        //     if (debugMode) console.log('Multi-check search already in progress, skipping');
        //     return;
        // }
        if ($(this).prop('checked')) {
            //個別のイベント種別チェックボックスからチェックを外して、非選択状態の状態にする
            $('.status-check').prop('checked', false);
        }else {
            // 自分自身のチェックは外させない(全て選択のチェックが外れるのは個別チェックボックスの押下時のみ)
            $(this).prop('checked', true);
        }
    });
    $(document).on('change', '#all-select-alc_type-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // if (deviceSearchProcessFlag) {
        //     if (debugMode) console.log('Multi-check search already in progress, skipping');
        //     return;
        // }
        if ($(this).prop('checked')) {
            //個別のイベント種別チェックボックスからチェックを外して、非選択状態の状態にする
            $('.alc_type-check').prop('checked', false);
        }else {
            // 自分自身のチェックは外させない(全て選択のチェックが外れるのは個別チェックボックスの押下時のみ)
            $(this).prop('checked', true);
        }
    });

    // イベント種別の個別チェックボックス
    $(document).on('change', '.status-check', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // 全て選択チェックボックスが選択状態だったら、非選択状態にする
        if ($('#all-select-status-btn').prop('checked')) {
            $('#all-select-status-btn').prop('checked', false);
        }
        if($('.status-check:checked').length <= 0) {
            //全てのチェックボックスのチェックが外れていたら全て選択を選択状態にする
            $('#all-select-status-btn').prop('checked', true);
        }
        // deviceSearchProcessFlag = true;
        // // 少し遅延させてから検索実行（複数のチェックボックスが連続で変更される場合を考慮）
        // setTimeout(function() {
        //     device_multiple_select_search();
        //     deviceSearchProcessFlag = false;
        // }, 200);
    });
    $(document).on('change', '.alc_type-check', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // 全て選択チェックボックスが選択状態だったら、非選択状態にする
        if ($('#all-select-alc_type-btn').prop('checked')) {
            $('#all-select-alc_type-btn').prop('checked', false);
        }
        if($('.alc_type-check:checked').length <= 0) {
            //全てのチェックボックスのチェックが外れていたら全て選択を選択状態にする
            $('#all-select-alc_type-btn').prop('checked', true);
        }
        // deviceSearchProcessFlag = true;
        // // 少し遅延させてから検索実行（複数のチェックボックスが連続で変更される場合を考慮）
        // setTimeout(function() {
        //     device_multiple_select_search();
        //     deviceSearchProcessFlag = false;
        // }, 200);
    });

    // 測定端末画面の検索処理（検索ボタン / キーワード検索の双方から呼び出す）
    // 共通の search.js は `#search-form` ベースで動作するが、当画面は `#device-search-form`
    // を使う独自構造のため、URL リダイレクト方式に統一する。
    function deviceExecuteSearch() {
        // グループ会社が選択されていない場合検索は行わない。
        let holdingInput = $('input[name="holding_id"]');
        if (holdingInput.length > 0 && !holdingInput.val()) {
            return;
        }

        const selector = '#device-search-form';

        // 1) まず現在のURLパラメータを保持（後で一部上書き）
        const current = new URLSearchParams(window.location.search);
        const params = [];

        function hasParam(list, key) {
            return list.some(function(p){ return p[0] === key; });
        }

        // 2) 既存の組織系パラメータは残す（保留中の選択があれば優先する）
        const pendingAff = window.devicePendingAffiliation || {};
        ['holding_id','company_id','section_id'].forEach(function(k){
            let v;
            if (Object.prototype.hasOwnProperty.call(pendingAff, k)) {
                v = pendingAff[k]; // 値ありなら新しい選択、null なら明示的にクリア
            } else {
                v = current.get(k);
            }
            if (v && !hasParam(params, k)) { params.push([k, v]); }
        });

        // 3) フォームの通常入力を反映（トークン、配列項目、空は除外）
        const items = $(selector).serializeArray();
        items.forEach(function(item){
            if (!item.name || item.name === '_token' || item.name === '_method') { return; }
            if (/^status\[/.test(item.name) || /^alc_type\[/.test(item.name)) { return; }
            if (item.value === '' || item.value == null) { return; }
            params.push([item.name, item.value]);
        });

        // 4) 複数選択（配列）は自前で収集し status[] / alc_type[] で追加
        const selectedStatus = [];
        $('.status-check:checked').each(function(){ selectedStatus.push($(this).val()); });
        const selectedAlcType = [];
        $('.alc_type-check:checked').each(function(){ selectedAlcType.push($(this).val()); });

        selectedStatus.forEach(function(v){ params.push(['status[]', v]); });
        selectedAlcType.forEach(function(v){ params.push(['alc_type[]', v]); });

        // 5) ツールバーのキーワード検索値は #device-search-form の外にあるため、別途取得して反映
        const keywordVal = $('#toolbar-keyword-search').val();
        if (keywordVal) {
            params.push(['keyword', keywordVal]);
        }

        // 6) ページングは1に戻す
        params.push(['page', '1']);

        // 7) 「検索」ボタン押下による検索であることを明示（自動検索防止用）
        params.push(['is_clear', 'false']);

        // 8) クエリ文字列を生成（[]はエンコードしない）
        const query = params.map(function(pair){
            const key = encodeURIComponent(pair[0]).replace(/%5B/g,'[').replace(/%5D/g,']');
            const val = encodeURIComponent(pair[1]);
            return key + '=' + val;
        }).join('&');

        // 9) 現在のパスに遷移（フルリロードで確実に反映）
        const newUrl = window.location.pathname + (query ? '?' + query : '');
        window.location.href = newUrl;
    }

    //検索ボタンクリックでformを動作させる
    $(document).on('click','#search-form-action_search', function(event) {
        event.preventDefault();
        event.stopPropagation();
        deviceExecuteSearch();
    });

    // ツールバーの「検索キーワードを入力」(#toolbar-keyword-search) を測定端末画面で機能させる。
    // 共通 search.js のハンドラは `#search-form` を前提とした load_contents 経路のため、
    // 当画面では keyword 値が URL/リクエストに反映されない。共通ハンドラを外し、
    // 検索ボタンと同じ URL リダイレクト処理に統一する。
    $(document).off('change', '#search-form, #toolbar-keyword-search');
    $(document).off('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset');

    $(document).on('change', '#toolbar-keyword-search', function() {
        deviceExecuteSearch();
    });
    $(document).on('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset', function(event) {
        event.preventDefault();
        event.stopPropagation();
        deviceExecuteSearch();
    });
    // 入力欄で Enter キー押下時にも検索を実行
    $(document).on('keydown', '#toolbar-keyword-search', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            deviceExecuteSearch();
        }
    });

    function device_update_search_url() {
        let params = [];
        let currentParams = new URLSearchParams(window.location.search);
        let removeKeys = [];

        $('#device-search-form').serializeArray().forEach(function(item) {
            removeKeys.push(item.name);
        });
        removeKeys.push('status');
        removeKeys.push('alc_type');

        currentParams.forEach(function(value, key) {
            if (key.indexOf('status') === 0 || key.indexOf('alc_type') === 0) {
                return;
            }
            if (removeKeys.indexOf(key) >= 0) {
                return;
            }
            params.push([key, value]);
        });

        $('#device-search-form').serializeArray().forEach(function(item) {
            if (!item.name || item.name === '_token' || item.name === '_method') {
                return;
            }
            if (item.name.indexOf('status') === 0 || item.name.indexOf('alc_type') === 0) {
                return;
            }
            if (item.value === '' || item.value === null || item.value === undefined) {
                return;
            }
            params.push([item.name, item.value]);
        });

        $('.status-check:checked').each(function() {
            params.push(['status[]', $(this).val()]);
        });
        $('.alc_type-check:checked').each(function() {
            params.push(['alc_type[]', $(this).val()]);
        });

        let queryString = params.map(function(pair) {
            let key = encodeURIComponent(pair[0]).replace(/%5B/g, '[').replace(/%5D/g, ']');
            let value = encodeURIComponent(pair[1]);
            return key + '=' + value;
        }).join('&');

        let newUrl = window.location.pathname + (queryString.length ? '?' + queryString : '');
        history.replaceState('', '', newUrl);
    }

    // その他のフォーム要素は通常の検索処理に任せる
    if (debugMode) {
        console.log('Device search events bound');
    }

    /**
     * 複数選択検索ハンドラー
     * フォームの現在の状態を全て取得してURLパラメータに反映して検索実行
     */
    function device_multiple_select_search() {
        try {
            if (debugMode) {
                console.log('Starting device multiple select search');
            }

            // URLパラメータを手動で構築（[]をエンコードしないため）
            let urlParams = [];

            // 既存のURLから組織関連パラメータを保持
            let currentUrl = new URL(window.location);
            let preserveParams = ['holding_id', 'company_id', 'section_id'];
            preserveParams.forEach(function(paramName) {
                let paramValue = currentUrl.searchParams.get(paramName);
                if (paramValue) {
                    urlParams.push(encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue));
                    if (debugMode) {
                        console.log('Preserving organizational parameter:', paramName, '=', paramValue);
                    }
                }
            });

            // 複数選択フィールド（チェックボックス）の現在の状態を取得
            let multiSelectFields = ['status', 'alc_type'];
            multiSelectFields.forEach(function(fieldName) {
                let checkedBoxes = $('#device-search-form .multi-check input[name="' + fieldName + '[]"]:checked');
                checkedBoxes.each(function() {
                    // []をエンコードせずにそのまま使用
                    urlParams.push(fieldName + '[]=' + encodeURIComponent($(this).val()));
                });

                if (debugMode) {
                    console.log(fieldName + ' current selected values:', checkedBoxes.map(function() { return $(this).val(); }).get());
                }
            });

            // その他の全てのフォーム要素の現在の値を取得（トークンは除外）
            $('#device-search-form input:not(.multi-check input), #device-search-form select, #device-search-form textarea').each(function() {
                let $element = $(this);
                let name = $element.attr('name');
                let value = $element.val();
                let type = $element.attr('type');

                // トークン関連のフィールドは除外
                if (name === '_token' || name === '_method' || type === 'hidden') {
                    if (debugMode) {
                        console.log('Skipping token/hidden field:', name);
                    }
                    return;
                }

                if (debugMode) {
                    console.log('Processing form element:', name, 'type:', type, 'value:', value);
                }

                // 名前があり、値が空でない場合のみ追加
                if (name && value !== '' && value !== null && value !== undefined) {
                    // チェックボックスやラジオボタンの場合はチェック状態を確認
                    if (type === 'checkbox' || type === 'radio') {
                        if ($element.is(':checked')) {
                            urlParams.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
                        }
                    } else {
                        // テキスト、セレクト、その他の要素
                        urlParams.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
                    }
                }
            });

            // ページを1にリセット
            urlParams.push('page=1');

            // 現在のパスを取得
            let currentPath = window.location.pathname;

            // 新しいURLを構築（[]はエンコードしない）
            let queryString = urlParams.join('&');
            let newUrl = currentPath + '?' + queryString;

            if (debugMode) {
                console.log('All current form values processed');
                console.log('New search URL:', newUrl);
                console.log('Query string with unencoded []:', queryString);
            }

            // ページを更新
            window.location.href = newUrl;

        } catch (error) {
            console.error('Device multiple select search error:', error);
            // エラーが発生した場合は通常の検索処理にフォールバック
            load_contents(null, false);
        }
    }
}
